import { render, staticRenderFns } from "./talentPool.vue?vue&type=template&id=0efa0d58"
import script from "./talentPool.vue?vue&type=script&lang=js"
export * from "./talentPool.vue?vue&type=script&lang=js"
import style0 from "./talentPool.vue?vue&type=style&index=0&id=0efa0d58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports